export default __webpack_public_path__ + "static/media/history-1.1052ca1d.png";